<template>
  <el-container class="sreen-times">
    <el-main v-if="!isSetting">
      <div class="flex-row-between home-main-box">
        <!-- 屏幕时间 -->
        <div class="home-main-left" v-loading="isloading">
          <div class="flex-row-between main-left-header">
            <div style="font-size: 20px;color: #333333;">{{$t('Screen Time')}}</div>
            <!-- Screen time select-->
            <el-select v-model="selectDate" @change="changeSelect" size="mini" placeholder="Today" class="select-time">
              <el-option
                v-for="(date, i) in allDates" :key="i" :label="date.label" :value="date.value">
              </el-option>
            </el-select>
          </div>
          <!-- 饼图 id="screen-time" -->
          <!-- <div class="flex-col-center" style="height:80%;width:100%">
            <div class="screen-allTimes">{{dateFormatterHome(allTimes)}}</div>
            <div v-if="screenActivities.length > 0"  id="screen-time" ref="chart" class="flex-row-center" style="width:100%;height:70%;"></div>
            <div v-else class="flex-col-center" style="height:80%">
              <img :src="$Image('nodata.png')" alt="">
              <div class="nodata-display">{{$t('No data found')}}</div>
            </div>
          </div> -->
          <div v-show="showpm" class="flex-col-center" style="height:80%;width:100%">
            <div class="screen-allTimes">{{dateFormatterHome(allTimes)}}</div>
            <div v-show="screenActivities.length > 0 && this.$route.query.android === 'Windows'"  id="screen-time" ref="chart" class="flex-row-center" style="width:100%;height:70%;"></div>
            <div v-show="mostUsedDatas.length > 0 && this.$route.query.android === 'Android'"  id="screen-time" ref="charts" class="flex-row-center" style="width:100%;height:70%;"></div>
          </div>
          <!--  no apps datas  -->
          <div v-if="!showpm" class="flex-col-center" style="height:80%">
            <img :src="$Image('nodata.png')" alt="">
            <div class="nodata-display">{{$t('No data found')}}</div>
          </div>
          <!-- end -->
        </div>
        <!-- 选择对应的控制屏幕 -->
        <div class="home-main-right" v-loading="isloading">
          <div class="main-right-header" style="font-size: 20px;color: #333333;">{{$t('Set Limits')}}</div>
          <div class="main-right-content">
            <div class="flex-row-between content-item" @click="onSetTime">
              <div class="flex-row-start" style="align-items:start;">
                <img :src="$Image('limit1.png')" alt="">
                <div class="item-text">
                  <div class="item-top">{{$t('Limit Screen Time')}}</div>
                  <div v-if="ScreenUsageTime !== 0" class="item-bom">{{$t('Allow: {time} ', { time: this.ScreenUsageTime })}}</div>
                  <div v-else class="item-bom"> {{$t('No Restriction')}}</div>
                </div>
              </div>
              <div class="right-icon"></div>
            </div>
            <div class="flex-row-between content-item" @click="onSetTime">
              <div class="flex-row-start" style="align-items:start;">
                <img :src="$Image('limit2.png')" alt="">
                <div class="item-text">
                  <div class="item-top">{{$t('Downtime')}}</div>
                  <div v-if="startTime !== '' && endTime !== ''" class="item-bom"> {{$t('Limit:')}} {{startTime}} - {{endTime}}</div>
                  <div v-else class="item-bom"> {{$t('No Restriction')}}</div>
                </div>
              </div>
              <div class="right-icon"></div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-main v-else-if="!setExcApp && isSetting" class="flex-row-between iphone_col_setexcapp">
      <div class="setItems">
        <SetUsageTime :title="$t('Limit Screen Time')" v-on:onSaveUseTime="onSaveUseTime" @onSetApp="onSetApp"  @onCancel="onCancel" :setException="setException" :OneRow="this.OneRow" :isPeriod="false"></SetUsageTime>
      </div>
      <div class="setItems">
        <SetUsageTime :title="$t('Downtime')" v-on:onSaveUsePeriod="onSaveUsePeriod" @onSetApp="onSetApp" :OneRow="this.OneRow" @onCancel="onCancel" :setException="setException" :isPeriod="true"></SetUsageTime>
      </div>
    </el-main>
    <el-main v-else class="full-content">
      <div class="set-app-exc">
        <SetExceptionApp @onCancelApp="onCancelApp"></SetExceptionApp>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import echarts from 'echarts'
import SetUsageTime from './Common/SetUsageTime.vue'
import SetExceptionApp from './Common/SetExceptionApp'
const add0 = (num) => {
  return num < 10 ? '0' + num : '' + num
}
const selectDate = {
  Last_7_Days: 'Last 7 Days',
  Yesterday_Days: 'Yesterday',
  Today_Days: 'Today'
}
export default {
  name: 'sreen-time',
  data () {
    return {
      setExcApp: false,
      showpm: false,
      setException: true,
      isloading: false,
      allTimes: 0,
      isSetting: false,
      NoData: false,
      selectDate: selectDate.Last_7_Days,
      allDates: [
        { label: this.$t('Today'), value: selectDate.Today_Days },
        { label: this.$t('Yesterday'), value: selectDate.Yesterday_Days },
        { label: this.$t('Last 7 Days'), value: selectDate.Last_7_Days }
      ],
      ScreenUsageTime: 0,
      appList: [],
      allClassify: [
        {value: 0, name: this.$t('Social contact')},
        {value: 0, name: this.$t('Other')},
        {value: 0, name: this.$t('Game')}
      ],
      other: null,
      game: null,
      social: null,
      ScreenTimes: null,
      ScreenTimesInterval: null,
      TimesInterval: null,
      startTime: '',
      mostUsedDatas: [],
      endTime: '',
      OneRow: {},
      screenActivities: [],
      allTimeDate: []
    }
  },
  components: {SetUsageTime, SetExceptionApp},
  methods: {
    getEachertDatas (activities) {
      let barDv = this.$refs.chart
      const myChart = echarts.init(barDv)
      const opts = {
        title: {
          text: ''
        },
        tooltip: {
          showContent: false
        },
        xAxis: {
          data: [activities[6].date, activities[5].date, activities[4].date, activities[3].date, activities[2].date, activities[1].date, activities[0].date],
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          max: 8,
          axisLabel: {
            showMaxLabel: true
          }
        },
        series: [
          {
            markLine: {
              data: [
                { type: 'average' }
              ],
              symbol: ['none', 'none'],
              position: 'insideTopCenter',
              large: true
            },
            type: 'bar',
            data: [activities[6].TotalTime, activities[5].TotalTime, activities[4].TotalTime, activities[3].TotalTime, activities[2].TotalTime, activities[1].TotalTime, activities[0].TotalTime],
            itemStyle: {
              normal: {
                color: function (params) {
                  if (activities[0].selectDate === 'Yesterday') {
                    let colorList = ['#fff', '#fff', '#fff', '#fff', '#fff', '#2bcf88', '#fff']
                    return colorList[params.dataIndex]
                  } else if (activities[0].selectDate === 'Today') {
                    let colorList = ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#2bcf88']
                    return colorList[params.dataIndex]
                  } else {
                    let colorList = ['#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88', '#2bcf88']
                    return colorList[params.dataIndex]
                  }
                },
                borderWidth: 1,
                borderColor: '#333',
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            }
          }
        ]
      }
      myChart.setOption(opts)
      window.onresize = myChart.resize
    },
    getEachertData (activities) {
      let barDv = this.$refs.charts
      const myChart = echarts.init(barDv)
      const opts = {
        legend: {
          orient: 'horizontal',
          bottom: 0,
          data: activities
        },
        series: [
          {
            name: this.$t('Screen time'),
            type: 'pie',
            radius: ['30%', '40%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              left: 20
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ['#FF7E55', '#FFB138', '#3AA7FF']
                  return colorList[params.dataIndex]
                },
                label: {
                  show: true,
                  // formatter: '{b}: {c} : {d} %'
                  formatter: function (obj) {
                    // console.log(obj.value)
                    if (obj.value === 0) {
                      return 0 + 'min'
                    }
                    const min = parseInt(obj.value / 1000 / 60)
                    const hours = parseInt(min / 60)
                    const sec = parseInt((obj.value / 1000) - (min * 60))
                    const minAdjust = parseInt(min - (60 * hours))
                    // const add0 = (num) => { return num < 10 ? '0' + num : '' + num }
                    if (sec < 60 && obj.value !== 0 && minAdjust === 0 && hours === 0) {
                      return '<1 mins'
                    } else if (hours === 0) {
                      return obj.name + ' : ' + minAdjust + 'mins'
                    } else {
                      return obj.name + ' : ' + hours + 'h' + minAdjust + 'mins'
                    }
                  }
                },
                labelLine: {
                  show: false
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: activities
          }
        ]
      }
      myChart.setOption(opts)
      window.onresize = myChart.resize
    },
    async getDatas () {
      console.log(this.selectDate)
      this.isloading = true
      this.isNoData = false
      try {
        // console.log(this.device)
        const datas = await this.$http.get(`MDM/AppActivity?date=${this.selectDate}`)
        this.appList = datas.data.data
        console.log(this.appList)
        if (this.appList.length !== 0) {
          this.showpm = true
          this.isNoData = true
          this.appList.map((c) => {
            c.Icons = `${this.STS_URL}` + '/' + c.AppNames + '.png'
          })
          // 筛选第三方App
          let appTypeList = []
          appTypeList = (this.appList.filter(c => c.Type === '1'))
          console.log(appTypeList)
          this.mostUsedDatas = (appTypeList.filter(c => c.TotalTime > 0)).slice(0, 3)
          // 其他类别
          this.other = appTypeList.filter(c => c.AppType === '0')
          let othertimes = 0
          this.other.forEach((c) => {
            othertimes += parseInt(c.TotalTime)
          })
          // 游戏类别
          this.game = appTypeList.filter(c => c.AppType === '1')
          let gametimes = 0
          this.game.forEach((c) => {
            gametimes += parseInt(c.TotalTime)
          })
          // 社交应用
          this.social = appTypeList.filter(c => c.AppType === '2')
          let socialtimes = 0
          this.social.forEach((c) => {
            socialtimes += parseInt(c.TotalTime)
          })
          // 分类后的屏幕使用总时长
          this.allClassify.map((c) => {
            if (c.name === 'Game') {
              c.value = 0
              c.value += gametimes
            } else if (c.name === 'Social') {
              c.value = 0
              c.value += socialtimes
            } else {
              c.value = 0
              c.value += othertimes
            }
          })
          console.log(this.allClassify)
          this.$nextTick(function () {
            this.getEachertData(this.allClassify)
          })
          // 总共时长
          this.allTimes = othertimes + gametimes + socialtimes
        } else {
          this.isNoData = true
          this.mostUsedDatas = []
          this.allTimes = 0
          this.showpm = false
        }
      } catch (error) {
        console.log(error)
      }
      this.isloading = false
    },
    async getData () {
      console.log(this.selectDate)
      this.isloading = true
      this.isNoData = false
      try {
        console.log(this.allTimeDate)
        const datas = await this.$http.get(`MDM/DayActivity?date=Last 7 Days`)
        this.screenActivities = datas.data.data
        console.log(datas.data.data)
        // let setData = datas.data.data
        if (this.screenActivities.length !== 0) {
          this.showpm = true
          this.isNoData = true
          let T = this.allTimeDate
          let list = []
          for (let index = 0; index < T.length; index++) {
            const element = {}
            element.date = T[index]
            list.push(element)
          }
          list.map((a) => {
            console.log(a)
            a.TotalTime = 0
            a.selectDate = this.selectDate
            for (let index = 0; index < datas.data.data.length; index++) {
              if (a.date === datas.data.data[index].Date) {
                a.TotalTime = Number(this.dateTimeHour(Number(datas.data.data[index].TotalTime)))
              }
            }
          })
          console.log(list)
          this.$nextTick(function () {
            this.getEachertDatas(list)
          })
        } else {
          this.showpm = false
        }
      } catch (error) {
        console.log(error)
      }
      this.isloading = false
    },
    // 获取屏幕设置的限制规则
    async getScreenLimit () {
      try {
        this.isloading = true
        const limitDatas = await this.$http.get('MDM/ScheduleRestriction')
        // console.log(limitDatas)
        let limitDataInterval = limitDatas.data.data
        console.log(limitDataInterval)
        let TypeList = {}
        TypeList = limitDataInterval.filter(c => c.title === 'TimeLenConfig')
        console.log(TypeList)
        if (TypeList.length !== 0) {
          this.ScreenTimes = TypeList[0]
          console.log(this.ScreenTimes)
          let TimesList = this.ScreenTimes.timeLen
          this.ScreenUsageTime = this.dateFormatterMin(parseInt(TimesList))
          this.OneRow.timeLengthTwo = TypeList[0]
        } else {
          this.ScreenUsageTime = 0
          this.OneRow.timeLengthTwo = {}
        }
        let appTypeListTwo = {}
        appTypeListTwo = limitDataInterval.filter(c => c.title === 'TimePeriodConfig')
        console.log(appTypeListTwo[0])
        if (appTypeListTwo.length !== 0) {
          this.ScreenTimesInterval = appTypeListTwo[0]
          console.log(this.ScreenTimesInterval)
          this.startTime = this.ScreenTimesInterval.startTime
          this.endTime = this.ScreenTimesInterval.endTime
          this.OneRow.timeLengthOne = appTypeListTwo[0]
        } else {
          this.endTime = ''
          this.startTime = ''
          this.OneRow.timeLengthOne = {}
        }
        console.log(this.OneRow)
        this.isloading = false
      } catch (e) {
        console.log(e)
      }
    },
    // 限制时长 保存逻辑
    async onSaveUseTime (obj) {
      console.log(obj.repeatValue)
      console.log(this.OneRow.timeLengthTwo)
      let weeks = '[' + obj.weeks.toString() + ']'
      console.log(weeks)
      if (this.OneRow.timeLengthTwo === undefined) {
        console.log('No id, ADD_ID')
        const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
          params: {
            timelen: obj.setUserTime,
            name: 'TimeLenConfig',
            week: weeks
          }
        })
        console.log('NO id, Add', datas.statusText)
        this.getScreenLimit()
      } else {
        console.log(obj.limitValue, this.OneRow.timeLengthTwo.id)
        if (obj.repeatValue === false || obj.limitValue === false) {
          const datasDelete = await this.$http.get('MDM/ScheduleRestriction/Delete', {
            params: {
              id: this.OneRow.timeLengthTwo.id
            }
          })
          if (datasDelete.statusText === 'OK') {
            this.getScreenLimit()
          }
          console.log('Delete id', this.OneRow.timeLengthTwo.id, datasDelete.statusText)
        } else {
          const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
            params: {
              timelen: obj.setUserTime,
              name: 'TimeLenConfig',
              id: this.OneRow.timeLengthTwo.id,
              week: weeks
            }
          })
          console.log('Add', this.OneRow.timeLengthTwo.id, datas.statusText)
          this.getScreenLimit()
        }
      }
      this.onCancel(true)
    },
    // 限制时段 保存逻辑
    async onSaveUsePeriod (obj) {
      console.log(obj)
      console.log(this.OneRow.timeLengthOne)
      let weeksTwo = '[' + obj.weeksTwo.toString() + ']'
      console.log(weeksTwo)
      if (this.OneRow.timeLengthOne === undefined) {
        const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
          params: {
            starthour: obj.startValue,
            endhour: obj.endValue,
            name: 'TimePeriodConfig',
            week: weeksTwo
          }
        })
        console.log(datas.statusText)
        this.getScreenLimit()
      } else {
        if (obj.repeatValueTwo === false || obj.limitValueTwo === false) {
          const datasDelete = await this.$http.get('MDM/ScheduleRestriction/Delete', {
            params: {
              id: this.OneRow.timeLengthOne.id
            }
          })
          if (datasDelete.statusText === 'OK') {
            this.getScreenLimit()
          }
          console.log(datasDelete.statusText, 'Delete')
        } else {
          const datas = await this.$http.get('MDM/ScheduleRestriction/Add', {
            params: {
              starthour: obj.startValue,
              endhour: obj.endValue,
              name: 'TimePeriodConfig',
              id: this.OneRow.timeLengthOne.id,
              week: weeksTwo
            }
          })
          console.log(datas.statusText)
          this.getScreenLimit()
        }
      }
      this.onCancel(true)
    },
    // 获取对应的日期数据
    async changeSelect () {
      if (this.$route.query.android === 'Windows') {
        this.setException = false
        this.allTimes = 0
        const datas = await this.$http.get(`MDM/DayActivity?date=${this.selectDate}`)
        let allTime = 0
        for (let index = 0; index < datas.data.data.length; index++) {
          allTime += Number(datas.data.data[index].TotalTime)
          console.log(allTime)
          this.allTimes = allTime
        }
        this.getData()
      } else {
        this.setException = true
        this.getDatas()
      }
    },
    dateFormatterHome: function (aDate) {
      let date = this.$Formatter.durationHome(aDate / 1000)
      return date
    },
    dateFormatterMin: function (aDate) {
      let date = this.$Formatter.durationOne(aDate * 60)
      return date
    },
    dateTimeHour (aDate) {
      let date = this.$Formatter.durationSreenTime(aDate / 1000)
      return date
    },
    onSetTime () {
      this.isSetting = true
    },
    onSetApp (type) {
      if (type) {
        this.setExcApp = type
      }
    },
    onCancel (t) {
      if (t === true) {
        this.getDatas()
        this.isSetting = false
      }
    },
    onCancelApp (t) {
      if (t === true) {
        this.setExcApp = false
      }
    },
    GetstartDateStr (a) {
      let dd = new Date()
      if (a) {
        dd.setDate(dd.getDate() - a)
      }
      let y = dd.getFullYear()
      let m = add0(dd.getMonth() + 1)
      let d = add0(dd.getDate())
      return y + '-' + m + '-' + d
      // return d
    }
  },
  async mounted () {
    this.getScreenLimit()
    let data = this.GetstartDateStr()
    let data1 = this.GetstartDateStr(1)
    let data2 = this.GetstartDateStr(2)
    let data3 = this.GetstartDateStr(3)
    let data4 = this.GetstartDateStr(4)
    let data5 = this.GetstartDateStr(5)
    let data6 = this.GetstartDateStr(6)
    let allData = [data, data1, data2, data3, data4, data5, data6]
    this.allTimeDate = allData
    this.changeSelect()
  },
  created () {
  },
  watch: {
    async '$route' (to, from) {
      console.log(to, from)
      if (to.name === 'SreenTime' && this.$route.query.android === 'Windows') {
        this.setException = false
        this.allTimes = 0
        const datas = await this.$http.get(`MDM/DayActivity?date=${this.selectDate}`)
        let allTime = 0
        for (let index = 0; index < datas.data.data.length; index++) {
          allTime += Number(datas.data.data[index].TotalTime)
          console.log(allTime)
          this.allTimes = allTime
        }
        this.getData()
      } else {
        this.setException = true
        this.getDatas()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.home-main-box{
  padding-top:40px;
  box-sizing: border-box;
  flex-wrap: wrap;
  height: 100%;
  .home-main-left{
    width: 49%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .main-left-header{
      height:69px;
      padding:0 25px;
      border-bottom:1px solid #e5e5e5;
      .el-input--mini .el-input__inner{
        width:160px;
        height:36px;
        border-radius:18px;
      }
    }
  }
  .home-main-right{
    width: 49%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px
      rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    .main-right-header{
      height:69px;
      line-height: 69px;
      color:#888888;
      font-size:16px;
      text-align:left;
      padding:0 25px;
      border-bottom:1px solid #e5e5e5;
    }
    .main-right-content{
      padding:0 25px;
      .content-item{
        padding:40px 20px;
        border-bottom:1px solid #e5e5e5;
        cursor: pointer;
        .item-text{
          margin-left:20px;
          text-align: left;
          .item-bom{
            margin-top:10px;
            color:#888;
            font-size: 18px;
          }
        }
        .right-icon{
          width:13px;
          height:24px;
          background:url('../../static/images/mro.png') 0 0 no-repeat;
        }
        &:hover{
          background-color:#f1faf7;
          .right-icon{
            background:url('../../static/images/mro_hove.png') 0 0 no-repeat;
          }
        }
      }
    }
  }
}
.setItems{
  width:48%;
  height:100%;
  background-color: #ffffff;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}
.set-app-exc {
  width: 100%;
  height: 100%;
}
.screen-allTimes{
  font-family: Nunito SemiBold;font-size: 36px;font-weight: normal;font-stretch: normal;line-height: 54px;color: #333333;
}
.item-top{
  font-size: 20px;color: #333333;
}
.full_content{
  width: 100%;
}
.sreen-times {
  width: 100%;
}
@media (min-width: 1024px){
  .sreen-times{
    height: 90%;
  }
}
@media (max-width: 1280px){
  .full_content{
    height: 105%;
  }
}
@media (max-width: 1024px){
   .full_content{
    height: auto;
  }
  .home-main-box, .iphone_col_setexcapp{
    flex-flow: column nowrap;
  }
  .home-main-box .home-main-left {
    width: 98%;
    height: 690px;
  }
  .home-main-box .home-main-right {
    width: 98%;
    height: 690px;
    margin-top: 30px;
  }
  .setItems{
    width: 98%;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SreenTime.vue